import { Button, Input, Modal, Typography } from 'antd'
import React, { useId, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from './form-item'

type RegenerateQuestionsButtonProps = {
    onRegenerate: (feedback: string) => Promise<unknown>
    loading: boolean
    label?: string
}

export function RegenerateQuestionsButton({ onRegenerate, loading, label }: RegenerateQuestionsButtonProps) {
    const { t } = useTranslation()

    const [open, setOpen] = useState(false)
    const [feedback, setFeedback] = useState('')
    const feedbackId = useId()

    return (
        <>
            <Button
                type="link"
                className="px-0"
                loading={loading}
                onClick={() => {
                    setFeedback('')
                    setOpen(true)
                }}
            >
                {label ?? t('Regenerate questions')}
            </Button>
            <Modal
                title={t('Regenerate questions')}
                open={open}
                okText={t('Generate new questions')}
                cancelText={t('Cancel')}
                confirmLoading={loading}
                cancelButtonProps={{ disabled: loading }}
                closable={!loading}
                maskClosable={!loading}
                keyboard={!loading}
                onCancel={() => {
                    if (!loading) {
                        setOpen(false)
                    }
                }}
                onOk={() => {
                    void onRegenerate(feedback)
                        .then(() => setOpen(false))
                        .catch(() => undefined)
                }}
            >
                <Typography.Paragraph>
                    {t('The new questions replace the current ones. Check the rejection settings again afterwards.')}
                </Typography.Paragraph>
                <FormItem
                    label={t('What would you like to change?')}
                    htmlFor={feedbackId}
                    extra={t('Optional. Leave this empty for a fresh set of questions.')}
                >
                    <Input.TextArea
                        id={feedbackId}
                        value={feedback}
                        onChange={(event) => setFeedback(event.target.value)}
                        disabled={loading}
                        autoSize={{ minRows: 3, maxRows: 8 }}
                        placeholder={t('For example: make the questions shorter and focus more on availability.')}
                    />
                </FormItem>
            </Modal>
        </>
    )
}
